import { axiosInstance } from '../../../shared/api';

export async function exportChatPdf() {
	const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
	const url = timezone
		? `chat/export/pdf?timezone=${encodeURIComponent(timezone)}`
		: `chat/export/pdf`;
	const response = await axiosInstance.get(url, {
		withCredentials: true,
		responseType: 'blob',
	});
	if (response.status !== 200) {
		throw new Error('Export failed');
	}
	const blob = response.data;
	const contentDisposition = response.headers['content-disposition'];
	let filename = 'chat-export.pdf';
	if (contentDisposition) {
		const match = contentDisposition.match(/filename="?([^"]+)"?/);
		if (match) filename = match[1].trim();
	}
	return { blob, filename };
}
